module.exports = __webpack_public_path__ + "static/img/chart2.a675129.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/chart2.png
// module id = ovla
// module chunks = 1